export const EMPTY_AMOUNT = "—";
